// Import model
import { ContactNoteCondition } from '../models/ContactNoteCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContactNoteIndexedFields } from '../models/ContactNoteIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContactNoteIndexedFieldsSerializer } from './ContactNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactNoteCondition - handles JSON serialization and deserialization with type validation
 */
export class ContactNoteConditionSerializer {
  /**
   * Deserializes a JSON string into a ContactNoteCondition instance
   */
  static deserialize(json: string): ContactNoteCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactNoteCondition instance
   */
  static fromObject(obj: any): ContactNoteCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactNoteCondition');
    }


    const instance: ContactNoteCondition = {
      fieldName: obj['fieldName'] as ContactNoteIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactNoteCondition instances
   */
  static deserializeArray(json: string): ContactNoteCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactNoteCondition instance to a JSON string
   */
  static serialize(instance: ContactNoteCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactNoteCondition instance to a plain object
   */
  static toObject(instance: ContactNoteCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContactNoteCondition instances to a JSON string
   */
  static serializeArray(instances: ContactNoteCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
